module.exports = __webpack_public_path__ + "static/media/close-icon-white.cf709deb.svg";